import { Component } from '@angular/core';
import { FormField } from '@angular/forms/signals';
import { AngularBaseFieldWidget } from '../angular-base-field-widget';
import { AngularNumberField } from '../angular-form-fields';


@Component({
	selector: 'angular-number-field',
	templateUrl: './angular-number-field.widget.html',
	imports: [FormField],
})

export class AngularNumberFieldWidget extends AngularBaseFieldWidget<AngularNumberField> {

}